import { useEffect, useRef } from 'react';
import { AppState } from 'react-native';
import AppStateHelper from 'src/presentation/helpers/AppStateHelper';

type Props = {
	onInit?: () => void;
	onForegrounded?: () => void;
	onBackgrounded?: () => void;
};

function useAppStateGlobalListener({ onInit, onForegrounded, onBackgrounded }: Props) {
	const appState = useRef(AppState.currentState);

	useEffect(() => {
		const appStateChangedListener = AppState.addEventListener('change', (nextAppState) => {
			if (
				AppStateHelper.isForegrounded({
					current: appState.current,
					next: nextAppState,
				})
			) {
				onForegrounded?.();
			} else {
				onBackgrounded?.();
			}

			appState.current = nextAppState;
		});

		onInit?.();

		return () => {
			appStateChangedListener.remove();
		};
	}, []);

	return null;
}

export default useAppStateGlobalListener;
